import { render, staticRenderFns } from "./ListEditField.vue?vue&type=template&id=519d0b5d&scoped=true"
import script from "./ListEditField.vue?vue&type=script&lang=js"
export * from "./ListEditField.vue?vue&type=script&lang=js"
import style0 from "./ListEditField.vue?vue&type=style&index=0&id=519d0b5d&prod&scoped=true&lang=css"
import style1 from "./ListEditField.vue?vue&type=style&index=1&id=519d0b5d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519d0b5d",
  null
  
)

export default component.exports